import { render, staticRenderFns } from "./Aichat.vue?vue&type=template&id=23848868&scoped=true&"
import script from "./Aichat.vue?vue&type=script&lang=js&"
export * from "./Aichat.vue?vue&type=script&lang=js&"
import style0 from "./Aichat.vue?vue&type=style&index=0&id=23848868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23848868",
  null
  
)

export default component.exports